import React,  { useEffect, useState } from "react";
import { Button, Nav, Navbar, Container, Tab, Row, Col } from 'react-bootstrap';
import { useLocation } from "react-router-dom";

import DashboardTab from "../components/DashboardTab";
import ViewProposalsTab from "../components/ViewProposalsTab";
import CreateProposalTab from "../components/CreateProposalTab";
import DepositNativeTab from "../components/DepositNativeTab";
import DepositERC20Tab from "../components/DepositERC20Tab";
import VoteTab from "../components/VoteTab";
import ChangeMembershipTab from "../components/ChangeMembershipTab";
import WhitelistActionsTab from "../components/WhitelistActionsTab";

import Lockbox from "../contracts/Lockbox.json"
import Web3 from 'web3';

import lockboxLogo from '../assets/lockbox_horz_white_text.svg';

import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles/App.css";

function LockboxPage () {
  const [address, setAddress] = useState("To populate the address field, click \"Set Address\"");
  const [lockboxAddress, setLockboxAddress] = useState("");
  const [lockbox, setLockbox] = useState({});
  const [login, setLogin] = useState(false);
  const [userType, setUserType] = useState("To populate the role field and access your roles, click \"Log In\"");
  const [hasWhitelist, setHasWhitelist] = useState(false);
  const [whitelistNames, setWhitelistNames] = useState([]);

  const location = useLocation();

  const loadWeb3 = async () => {
    // TODO for Charles: window.ethereum.enable is going to be deprecated very soon, look into
    // fix laid out here: https://docs.metamask.io/guide/ethereum-provider.html#ethereum-provider-api
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable();
    }
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider);
    }
    else {
      window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!');
    }
  }


  const loadUserData = () => {
    const web3 = window.web3;

    // TODO: figure out how to deal with getting the correct lockbox onto the frontend in a more user friendly way
    if (location.state != null) {
      let { lockboxAddr } = location.state;
      setLockboxAddress(lockboxAddr);
      try {
        const instance = new web3.eth.Contract(Lockbox.abi, lockboxAddr);
        setLockbox(instance);
      } catch (error) {
        console.log(error)
        window.alert('Invalid Lockbox contract address.');
      }
    } else {
      setLockboxAddress("Set address on previous page")
    }
  }


  const loadMetaMask = async () => {
    const web3 = window.web3;
    // find the metamask account
    let accounts = await web3.eth.getAccounts().then();
    setAddress(accounts[0]);

    // this might be problematic to automatically assume everything sets login = true,
    // even if you are not a member
    setLogin(true);
  }


  const getUserType = async () => {
    let role = await lockbox.methods.getMyRole().call({ from: address });
    let whitelistPerms = await lockbox.methods.viewWhitelist(address).call({ from: address });
    if (whitelistPerms.length > 0) {
      setHasWhitelist(true)
      var temp = [];
      for (var i = 0; i < whitelistPerms.length; i++) {
        temp.push(whitelistPerms[i][0]);
      }
      setWhitelistNames(temp)
    }
    else {
      setHasWhitelist(false);
      setWhitelistNames([]);
    }

    if (role == 1) {
      setUserType("Member");
    }
    else if (role == 2) {
      setUserType("Admin");
    }
    else {
      setUserType("Not member");
    }
  }

  useEffect(() => {
    loadWeb3();
    loadUserData();
  }, []);


  return (
    <div className='app'>
      <Navbar bg="dark" variant="dark">
        <Container>
          <Navbar.Brand href="/">
            <img
              alt=""
              src={lockboxLogo}
              height="32"
              className="d-inline-block align-bottom"
            />
          </Navbar.Brand>
          <Nav className="justify-content-end">
            <Button variant="dark" onClick={loadMetaMask}>Set Address</Button>
            <Button variant="dark" onClick={getUserType} disabled={!login}>Log In</Button>
          </Nav>
        </Container>
      </Navbar>
      <br />
      <br />
      <h2>Welcome to your Lockbox.</h2>
      <p>Your address: {address}<br />Your Lockbox address: {lockboxAddress}<br />Your role: {userType}</p>
      <br />
      <br />
      <Tab.Container defaultActiveKey="0" className="sidebar">
        <Row>
          <Col sm={1}></Col>
          <Col sm={3}>
            <div className="sidebar-background">
              <Nav variant="pills" className="flex-column">
                <Nav.Item>
                  <Nav.Link eventKey="0">Dashboard</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="1">Active Proposals</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="2">Make New Proposal</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="3">Deposit Native Tokens</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="4">Deposit ERC20 Tokens</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="5" disabled={userType != "Admin"}>Vote on Proposals</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="6" disabled={userType != "Admin"}>Change Membership</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="7">Whitelisted Actions</Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          </Col>
          <Col sm={7}>
            <Tab.Content>
              <Tab.Pane eventKey="0">
                {userType == "Admin" || userType == "Member" ?
                  <DashboardTab lockbox={lockbox} address={address} />
                  : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="1">
                {userType == "Admin" || userType == "Member" ?
                  <ViewProposalsTab lockbox={lockbox} address={address} />
                  : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="2">
                {userType == "Admin" || userType == "Member" ?
                  <CreateProposalTab lockbox={lockbox} address={address} />
                  : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="3">
                {userType == "Admin" || userType == "Member" ?
                  <DepositNativeTab lockbox={lockbox} address={address} />
                  : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="4">
                {userType == "Admin" || userType == "Member" ?
                  <DepositERC20Tab lockbox={lockbox} address={address} lockboxAddress={lockboxAddress} />
                  : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="5">
                {userType == "Admin" ?
                  <VoteTab lockbox={lockbox} address={address} />
                  : userType == "Member" ? <h3>Only admins can access this feature</h3> : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="6">
                {userType == "Admin" ?
                  <ChangeMembershipTab lockbox={lockbox} address={address} />
                  : userType == "Member" ? <h3>Only admins can access this feature</h3> : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
              <Tab.Pane eventKey="7">
                {hasWhitelist == true ?
                  <WhitelistActionsTab lockbox={lockbox} address={address} whitelistNames={whitelistNames} />
                  : userType == "Admin" || userType == "Member" ?
                    <h3>You do not have whitelisted permissions for any integrated dapps.</h3>
                    : <h3>Please log in to access Lockbox functionality.</h3>}
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <br />
      <br />
    </div>
  );


}

export default LockboxPage;
